var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coupon-import" }, [
    _c("input", {
      ref: "excel-upload-input",
      staticClass: "excel-upload-input",
      attrs: { type: "file", accept: ".xlsx, .xls" },
      on: { change: _vm.handleClick },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "import-container" },
      [
        _c(
          "el-button",
          {
            attrs: { loading: _vm.loading, type: "primary" },
            on: { click: _vm.handleUpload },
          },
          [_vm._t("default", [_vm._v("导入商品")])],
          2
        ),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.downloadTemplate } },
          [_vm._v("下载模板")]
        ),
        _vm._v(" "),
        _c(
          "el-popover",
          { attrs: { placement: "right", width: "400", trigger: "hover" } },
          [
            _c("div", [
              _c("p", [_vm._v("Excel导入格式说明：")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "第一行需包含以下列标题: ID、编码、名称、零售价、状态、品牌、供应商"
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("状态列内容为: 已上架 或 未上架")]),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticStyle: { "border-collapse": "collapse", width: "100%" },
                  attrs: { border: "1", cellpadding: "3" },
                },
                [
                  _c("tr", [
                    _c("th", [_vm._v("ID")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("编码")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("名称")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("零售价")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("状态")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("品牌")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("供应商")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", [_vm._v("1001")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("SKU001")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("示例商品1")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("99.00")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("已上架")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("品牌A")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("供应商A")]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  slot: "reference",
                  type: "text",
                  icon: "el-icon-question",
                },
                slot: "reference",
              },
              [_vm._v("导入说明")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }